import { i18n } from '@/plugins/i18n/i18n';
import { UserRoleTypes } from '@/utils/UserManagementUtils';

export class UserDetail {
  private readonly _loginName: string;
  private _userRole: UserRoleTypes;
  private _userRoleLabel: string;
  private _roleId?: string | null;

  constructor(
    loginName: string,
    userRole: UserRoleTypes,
    roleId?: string | null
  ) {
    this._loginName = loginName;
    this._userRole = userRole;
    this._userRoleLabel = this.generateUserRoleLabel(userRole);
    this._roleId = roleId;
  }

  set userRole(userRole: UserRoleTypes) {
    this._userRole = userRole;
    this._userRoleLabel = this.generateUserRoleLabel(userRole);
  }

  set roleId(roleId: string | null | undefined) {
    this._roleId = roleId;
  }

  get loginName(): string {
    return this._loginName;
  }

  get userRole(): UserRoleTypes {
    return this._userRole;
  }

  get userRoleLabel(): string {
    return this._userRoleLabel;
  }

  get roleId(): string | null | undefined {
    return this._roleId;
  }

  private generateUserRoleLabel(userRole: UserRoleTypes) {
    return userRole === UserRoleTypes.Admin
      ? i18n.tc('commonSetting.userManagement.adminRole')
      : i18n.tc('commonSetting.userManagement.generalRole');
  }
}
